module.exports = __webpack_public_path__ + "img/MDX.e3250046.webp";